import * as React from 'react';
import isEqual from 'react-fast-compare';
import styled from 'styled-components';

type Props = {
    breadcrumbs: React.ReactNode;
    secondaryNavigation: React.ReactNode;
};

const BreadcrumbList = ({ breadcrumbs, secondaryNavigation }: Props) => {
    return (
        <StyledBreadcrumbList>
            <StyledBreadcrumbContainer>
                <StyledBreadcrumbs>{breadcrumbs}</StyledBreadcrumbs>
                {secondaryNavigation}
            </StyledBreadcrumbContainer>
        </StyledBreadcrumbList>
    );
};

export default React.memo<Props>(BreadcrumbList, isEqual);

const StyledBreadcrumbList = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin-bottom: 30px;

    @media (max-width: ${({ theme }) => theme.breakpoints.tabletNarrowWidth}) {
        margin-bottom: 0;
    }
`;

const StyledBreadcrumbContainer = styled.div`
    display: flex;
    flex-direction: row;
    max-width: 1200px;
    align-self: center;
    width: calc(100% - 40px);

    @media print {
        display: none;
    }
`;

const StyledBreadcrumbs = styled.ul`
    flex: 1 1 auto;
    margin: 19px 0;
    padding: 0;
    color: ${({ theme }) => theme.colors.grey100};
    font-size: 13px;

    a {
        text-decoration: none;
    }
`;
